const businessRepository = (fetch: CustomFetch) => ({
  async getPublicInfo(businessId: string) {
    return fetch<PublicBusinessInfo>(`/v2/direct/businesses/${businessId}/public-information`)
  },
})

export default businessRepository
